module.exports = __webpack_public_path__ + "media/img/Landing_Page/S2U-Muhammad-Jazli-Adam-f2a6008b41bb11fce3cfd05a4a8784b1.jpg";